import { render, staticRenderFns } from "./allpush.vue?vue&type=template&id=21c81ef0&scoped=true&"
import script from "./allpush.vue?vue&type=script&lang=js&"
export * from "./allpush.vue?vue&type=script&lang=js&"
import style0 from "./allpush.vue?vue&type=style&index=0&id=21c81ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c81ef0",
  null
  
)

export default component.exports